/**
 * 답례품 "수신자" 페이지(쿠폰 교환/환불/연장, 배송지 입력) 링크 조립 유틸.
 *
 * REACT_APP_GIFT_RECIPIENT_BASE_URL 이 설정된 빌드에서는 수신자 전용 도메인으로
 * 링크를 만든다. 수신자 전용 배포는 라우트에서 gift-store 프리픽스를 제거했으므로
 * 경로도 짧아진다.
 *   설정 시: https://demo.gift.smartnanumi.com/coupon/ABC123
 *   미설정 시(기존 동작): {현재 오리진}/gift-store/coupon/ABC123
 *
 * ⚠️ 구매자/판매자용 링크(/gift-store/order/..., /gift-brand/...)는 기존 도메인을
 * 유지해야 하므로 이 유틸을 쓰면 안 된다. 수신자에게 전달되는 링크 전용.
 */

/** 수신자 전용 도메인 (미설정 시 빈 문자열) */
export const giftRecipientBaseUrl = (
  process.env.REACT_APP_GIFT_RECIPIENT_BASE_URL ?? ''
)
  .trim()
  .replace(/\/+$/, '');

const buildUrl = (path: string): string =>
  giftRecipientBaseUrl
    ? `${giftRecipientBaseUrl}${path}`
    : `${window.location.origin}/gift-store${path}`;

/** 쿠폰 받기(교환 신청) — 상주가 조문객에게 공유하는 링크 */
export const giftCouponRecipientUrl = (couponCode: string): string =>
  buildUrl(`/coupon/${couponCode}`);

/** 쿠폰 환불 신청 */
export const giftCouponRefundRecipientUrl = (couponId: string): string =>
  buildUrl(`/coupon/${couponId}/refund`);

/** 쿠폰 재발급(연장) 신청 */
export const giftCouponRenewalRecipientUrl = (couponId: string): string =>
  buildUrl(`/coupon/${couponId}/renewal`);

/** 배송지 입력 — 상주가 조문객에게 공유하는 링크 */
export const giftDeliveryRecipientUrl = (deliveryCode: string): string =>
  buildUrl(`/delivery/${deliveryCode}`);

/**
 * 관리자 확인용(비기록) 미리보기 링크.
 * secretKey 쿼리를 붙이면 수신자 열람/조회 기록 없이 페이지 동작을 확인할 수 있다.
 * (GiftStoreAuthGate / GiftCouponRedeemPage 가 이 키를 검증 — 수신자 도메인 빌드도
 * 같은 REACT_APP_GIFT_STORE_ADMIN_PREVIEW_KEY 를 사용해야 함)
 */
export const giftRecipientAdminPreviewUrl = (
  kind: 'coupon' | 'delivery',
  code: string,
): string =>
  `${buildUrl(`/${kind}/${code}`)}?secretKey=${encodeURIComponent(
    process.env.REACT_APP_GIFT_STORE_ADMIN_PREVIEW_KEY ?? '',
  )}`;
